export function formatNum(value: number): string {
    if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
    return value.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatPrice(value: number | null | undefined): string {
    if (value == null) return "-";
    return `$ ${formatNum(value)}`;
}

export function formatFullPrice(value: number | null | undefined): string {
    if (value == null) return "";
    return `$ ${value.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatCell(value: string | number | null): string {
    if (value == null) return "-";
    if (typeof value === "string") return value;
    return formatNum(value);
}

export function formatVariationPct(value: number | null | undefined): string {
    if (value == null) return "-";
    return `${value > 0 ? "+" : ""}${value.toFixed(2)}%`;
}

export function variationColor(value: number | null | undefined): "success.main" | "error.main" | "text.secondary" {
    if (value == null) return "text.secondary";
    return value >= 0 ? "success.main" : "error.main";
}

export const truncateSx = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
};

export function getTableCellSx() {
    const cellSx = {
        px: { xs: 0.5, sm: 1.5 },
        py: 0.75,
        fontSize: { xs: "0.7rem", sm: "0.8rem" },
        whiteSpace: "nowrap" as const,
        overflow: "hidden",
        textOverflow: "ellipsis",
    };
    const headerCellSx = {
        ...cellSx,
        fontWeight: 700,
        fontSize: { xs: "0.65rem", sm: "0.75rem" },
    };
    return { cellSx, headerCellSx };
}
